import { isConsumer as isConsumerFromSession } from 'owa-session-store';

export function isDev(): boolean {
    return process.env.NODE_ENV === 'dev';
}

export function isConsumer(): boolean {
    return isConsumerFromSession();
}
